import { render, staticRenderFns } from "./templateInfo.vue?vue&type=template&id=4f86dec5&scoped=true"
import script from "./templateInfo.vue?vue&type=script&lang=js"
export * from "./templateInfo.vue?vue&type=script&lang=js"
import style0 from "./templateInfo.vue?vue&type=style&index=0&id=4f86dec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f86dec5",
  null
  
)

export default component.exports